function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#4d4d4f}.cls-3{fill:#f26524}.cls-6{fill:#ffd15c}.cls-7{fill:#fff4ef}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_537",
  fill: "#fff",
  d: "M6 0h38a6 6 0 0 1 6 6v38a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "surgeon",
  transform: "translate(-9.293 7)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1107",
  d: "M156.87 125.62l-1.929-1.332-1.928 1.331c-7.142 4.929-12.96 12.923-5.818 17.854l7.747 1.332 7.747-1.331c7.142-4.931 1.323-12.925-5.818-17.854",
  className: "cls-2",
  transform: "translate(-120.649 -115.549)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1108",
  d: "M137.3 11.449c0 6.324-18.559 6.324-18.559 0S122.9 0 128.022 0s9.28 5.126 9.28 11.449",
  className: "cls-3",
  transform: "translate(-93.688)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1109",
  fill: "#40596b",
  d: "M50.293 307.289h-32l.683-7.262a9.79 9.79 0 0 1 5.485-7.358 9.016 9.016 0 0 1 3.849-.863h11.968a9.008 9.008 0 0 1 3.9.885 9.814 9.814 0 0 1 5.435 7.336z",
  transform: "translate(0 -271.289)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1110",
  fill: "#ffcab2",
  d: "M50.293 307.289h-32l.683-7.262a9.79 9.79 0 0 1 5.485-7.358 9.016 9.016 0 0 1 3.849-.863h11.968a9.008 9.008 0 0 1 3.9.885 9.814 9.814 0 0 1 5.435 7.336z",
  transform: "translate(0 -271.289)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2663",
  transform: "translate(33.96 11.211)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_498",
  d: "M0 0H0.001V0.003H0z",
  className: "cls-6",
  transform: "translate(0 8.898)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_499",
  d: "M0 0H0.003V0.005H0z",
  className: "cls-6",
  transform: "translate(.355)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2664",
  transform: "translate(26.34 8.662)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1111",
  d: "M139.687 125.307c.284 1.276.135 2.4-.337 2.518s-1.083-.827-1.367-2.1-.135-2.4.335-2.518 1.084.828 1.368 2.1",
  className: "cls-2",
  transform: "translate(-137.839 -123.195)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1112",
  d: "M344.985 125.307c-.284 1.276-.134 2.4.337 2.518s1.083-.827 1.367-2.1.135-2.4-.335-2.518-1.082.828-1.368 2.1",
  className: "cls-2",
  transform: "translate(-330.908 -123.195)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2665",
  transform: "translate(27.092 3.351)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1113",
  d: "M162.971 58.79c-1.977 6.556-6.718 7.055-6.718 7.055s-4.74-.5-6.717-7.055a12.258 12.258 0 0 1-.171-6.269s.543-4.863 6.888-4.863 6.89 4.863 6.89 4.863a12.267 12.267 0 0 1-.172 6.269",
  className: "cls-7",
  transform: "translate(-149.011 -47.658)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1114",
  d: "M189.411 271.953l-4.8-9.112v-2.19a7.649 7.649 0 0 0 4.846 3.211 7.627 7.627 0 0 0 4.817-3.166v2.144z",
  className: "cls-7",
  transform: "translate(-182.212 -245.674)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_1116",
  d: "M168.372 291.808h-1.127l-4.859 9.111-4.8-9.111H156.4c-.236 0-.468.02-.7.04l6.634 12.007 6.921-12c-.293-.028-.586-.05-.885-.05",
  className: "cls-3",
  transform: "translate(-128.16 -271.29)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1117",
  d: "M156.246 35.391a28.7 28.7 0 0 1 7.244.87 7.278 7.278 0 0 0-14.487 0 28.656 28.656 0 0 1 7.243-.87",
  className: "cls-3",
  transform: "translate(-121.912 -27.598)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2666",
  transform: "translate(27.06 8.578)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1118",
  d: "M319.849 122.005l-2.8 6.1.322.164 2.842-6.186c-.115-.031-.244-.053-.36-.082",
  className: "cls-2",
  transform: "translate(-305.703 -122.005)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1119",
  d: "M148.905 122.005l2.8 6.1-.322.164-2.842-6.186c.115-.031.244-.053.36-.082",
  className: "cls-2",
  transform: "translate(-148.545 -122.005)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2667",
  transform: "translate(28.733 13.74)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1120",
  fill: "#ffa277",
  d: "M183.929 198.916l-.337-2.931-4.6-.572-4.6.572-.338 2.931h-.654s3.044 4.906 5.6 4.906 5.608-4.906 5.608-4.906z",
  transform: "translate(-173.396 -195.414)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_500",
  fill: "#f2f2f2",
  d: "M0 0H6.259V1.5H0z",
  transform: "translate(10.418 18.825)"
})));

function SvgColorIconSurgeons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "color-icons_Surgeons",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIconSurgeons);
export default __webpack_public_path__ + "static/media/colorIconSurgeons.f981aed7.svg";
export { ForwardRef as ReactComponent };